import { render, staticRenderFns } from "./InventarioResumen.vue?vue&type=template&id=e01ecd66&scoped=true"
import script from "./InventarioResumen.vue?vue&type=script&lang=js"
export * from "./InventarioResumen.vue?vue&type=script&lang=js"
import style0 from "./InventarioResumen.vue?vue&type=style&index=0&id=e01ecd66&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e01ecd66",
  null
  
)

export default component.exports